import { useMutation } from '@tanstack/react-query';
import { useUserState } from '../../hooks/context/useUserState';
import { requestApp } from '../requests/requestApp';
import { SET_MENU_ID } from '../../constants';
import { fetchAndInjectAppStyles } from '../../utils/fetchAndInjectAppStyles';

type getConfigArgs = {
  sessionToken: string;
};

export const useApp = () => {
  const {
    dispatch,
    state: { token },
  } = useUserState();

  const { error, mutateAsync: getApp } = useMutation({
    mutationFn: ({ sessionToken }: getConfigArgs) => requestApp(sessionToken),
    onSuccess: async (response, variables) => {
      if (response.mainMenu.menuId) {
        dispatch({ type: SET_MENU_ID, payload: response.mainMenu.menuId });
      }
      await fetchAndInjectAppStyles(
        response.styleIds,
        variables.sessionToken || token
      );
    },
  });

  return { error, getApp };
};
